module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Media/Movie-Lane #2-98068f5493f7e1ca75044fa6dc071f48.svg";